import React from 'react'

export interface VideoModuleProps {
  data: {
    video: {
      asset: {
        url: string
      }
    }
  }
}

export const VideoModule = ({ data }: VideoModuleProps) => {
  const {
    url
  } = data.video.asset
  return (
    <div className="container--xl outer mxa py2 p05 s1 al x">
      <video className='x' muted={true} autoPlay={true} loop={true} playsInline={true}>
        <source src={url} />
      </video>
    </div>
  )
}